import React from 'react';
import { useParams } from 'react-router';

import ContentWrapper from 'components/ContentWrapper/ContentWrapper';
import useGetRegistrationDetails from 'hooks/useGetRegistrationDetails';
import { t } from 'locales/i18n';
import CasIdRequirement from 'pages/Registration/CasIdRequirement';
import StudentIdRequirement from 'pages/Registration/StudentIdRequirement';

const Registration = () => {
  const { interviewUid = '' } = useParams();
  const { data } = useGetRegistrationDetails(interviewUid);

  return (
    <ContentWrapper title={t('Registration')}>
      <StudentIdRequirement
        data={data?.studentIdRequirement}
        interviewUid={interviewUid}
      />
      <CasIdRequirement
        data={data?.casIdRequirement}
        interviewUid={interviewUid}
      />
    </ContentWrapper>
  );
};

export default Registration;
